import { ConstantsService } from './constants.service';
import { AutenticacionService } from './autenticacion.service';
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';

@Injectable()
export class ReportesService {
  public service_url: string;
  public modulo_url: string;
  public api_url: string;
  constructor(private http: Http, private authService: AutenticacionService, private constantsService: ConstantsService) {
    this.api_url = this.constantsService.apiURL;
    this.modulo_url = '/reportes';
    this.service_url = this.api_url + this.modulo_url;
  }

  getListaReportes() {
    return [
      {'id': 1, 'nombre': 'Por Inversionista', 'ruta': '/catalogo-reportes/reporte-por-inversionista'},
      {'id': 2, 'nombre': 'Resumen de Obra', 'ruta': '/catalogo-reportes/reporte-resumen-obra'},
      {'id': 3, 'nombre': 'Por Obra', 'ruta': '/catalogo-reportes/reporte-por-obra'},
      {'id': 4, 'nombre': 'Balance KR', 'ruta': '/catalogo-reportes/reporte-balance-kr'},
      {'id': 5, 'nombre': 'P. Equilibrio', 'ruta': '/catalogo-reportes/reporte-equilibrio'},
      {'id': 6, 'nombre': 'Resumen de Diferencia', 'ruta': '/catalogo-reportes/reporte-resumen-diferencia'},
      {'id': 7, 'nombre': 'Reporte de Saldos', 'ruta': '/catalogo-reportes/reporte-saldos'},
      {'id': 8, 'nombre': 'Depósitos en Garantía', 'ruta': '/catalogo-reportes/reporte-depositos-garantia'},
      {'id': 9, 'nombre': 'Reporte de Cobranza', 'ruta': '/catalogo-reportes/reporte-cobranza'},
      {'id': 10, 'nombre': 'Reporte Resumen Oyv', 'ruta': '/catalogo-reportes/reporte-resumen-oyv'}
    ];
  }

  public getFechaActual () {
    return this.http.get(this.service_url + '/fecha', this.authService.getAuthHeaders());
  }

  public canSecurity() {
    return this.authService.canSecurity();
  }

  public activeSecurityModule(password) {
    const data = {password:password}
    return this.http.post(this.service_url + '/key', data, this.authService.getAuthHeaders());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/reportes.service.ts